// extracted by mini-css-extract-plugin
export default {"container":"CardsContainer_container__b7aVE","cardcontainer":"CardsContainer_cardcontainer__zj6Lu","paginado":"CardsContainer_paginado__1MvCm"};